import SmartLabel from "@/domain/enums/SmartLabel";
import { cn } from "@/lib/utils";

const smartLabelOutsideClassName = {
    [SmartLabel.Focus]: "border-TypeMail-FocusDark bg-TypeMail-FocusLight",
    [SmartLabel.PourInfo]:
        "border-TypeMail-InformationDark bg-TypeMail-InformationDark",
    [SmartLabel.Newsletter]:
        "border-TypeMail-NewsletterDark bg-TypeMail-NewsletterDark",
    [SmartLabel.Suspect]: "border-TypeMail-SuspectDark bg-TypeMail-SuspectDark",
    [SmartLabel.Autre]: "border-TypeMail-OtherDark bg-TypeMail-OtherDark",
    [SmartLabel.Traites]: "border-TypeMail-TraitesDark bg-TypeMail-TraitesDark",
};

const smartLabelInsideClassName = {
    [SmartLabel.Focus]: "bg-TypeMail-FocusDark",
    [SmartLabel.PourInfo]: "bg-white",
    [SmartLabel.Newsletter]: "bg-white",
    [SmartLabel.Suspect]: "bg-white",
    [SmartLabel.Autre]: "bg-white",
    [SmartLabel.Traites]: "bg-white",
};

type SmartLabelIconProps = {
    smartLabel: SmartLabel;
};

const SmartLabelIcon = ({ smartLabel }: SmartLabelIconProps) => (
    <div>
        <div
            className={cn(
                "flex h-3 w-5 items-center justify-center rounded-full border p-1",
                smartLabelOutsideClassName[smartLabel],
            )}
        >
            <div
                className={cn(
                    "h-1.5 w-1.5 rounded-full",
                    smartLabelInsideClassName[smartLabel],
                )}
            />
        </div>
    </div>
);

export default SmartLabelIcon;
